import React, { useEffect, useState } from 'react';
import { motion } from "framer-motion";
import { Link } from 'react-router-dom';
import headerLogo from "../medias/header-logo.png";
import MoblieHeaderFbAd from './MoblieHeaderFbAd';

const HeaderFbAd = () => {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    let lastScrollTop = 0;
    const handleScroll = () => {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      setIsScrolled(scrollTop > lastScrollTop);
      lastScrollTop = scrollTop;
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <motion.div
      style={{ boxShadow: isScrolled ? '0px 2px 5px rgba(0, 0, 0, 0.2)' : 'none' }}
      className="sticky top-0 left-0 right-0 z-50 bg-[#3B79B3] h-[66px]"
    >
      <div className="flex justify-between items-center max-w-[1120px] mx-auto pt-[12px] px-[24px]">
        <Link to="/">
          <img className="cursor-pointer" src={headerLogo} alt="CustomSync" style={{ height: '40px' }} />
        </Link>
        <div className="md:flex items-center hidden">
          <a href="https://customsync.app/login?signup=true">
            <div className="cursor-pointer text-white text-nowrap bg-[#F29E13] px-[16px] py-[8px] rounded-lg font-bold orange-button">
              Start Your Free Trial
            </div>
          </a>
        </div>
        <div className="md:hidden block">
          <MoblieHeaderFbAd />
        </div>
      </div>
    </motion.div>
  );
};

export default HeaderFbAd;
